import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ManualTotal_Update_Mutation = graphql(`
  mutation MissionServicesInfoForm_ManualTotal_Update(
    $manualTotal: ResolvableServiceValueInput!
    $serviceUsagesGroupId: Id!
    $serviceUserId: Id!
    $versionData: VersionDataInput
  ) {
    updateMissionManualTotal(
      manualTotal: $manualTotal
      serviceUsagesGroupId: $serviceUsagesGroupId
      serviceUserId: $serviceUserId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useUpdateMissionManualTotalMutation = () =>
  useGraphQLMutation(MissionServicesInfoForm_ManualTotal_Update_Mutation);
